/*
 *  I21RENDETASI18n.js
 *
 *  Created by Sébastien Hecart on 2019-01-18 01:08:09 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I21RENDETAS_SECTION_0_TITLE: "Calculez l'ETAS d'une chaudière en renseignant les données du fabricant",
  I21RENDETEAS_modele_generateur: 'Modèle du générateur',
  I21RENDETAS_in_rendement30PCI: 'Rendement à 30% PCI',
  I21RENDETAS_in_rendement100PCI: 'Rendement à 100% PCI',
  I21RENDETAS_in_rendement30PCS: 'Rendement à 30% PCS',
  I21RENDETAS_in_rendement100PCS: 'Rendement à 100% PCS',
  I21RENDETAS_in_puissance30: 'Puissance électrique à 30%',
  I21RENDETAS_in_puissance100: 'Puissance électrique à 100%',
  I21RENDETAS_in_puissanceArret: "Puissance électrique à l'arrêt",
  I21RENDETAS_in_perteArret: "Perte à l'arrêt",
  I21RENDETAS_in_puissanceVeilleuse: 'Puissance de la veilleuse',
  I21RENDETAS_in_puissanceMin: 'Puissance minimum',
  I21RENDETAS_in_puissanceMax: 'Puissance maximum',
  I21RENDETAS_SECTION_1_TITLE: 'Résultats',
  I21RENDETAS_res_F1: 'F1',
  I21RENDETAS_res_F2: 'F2',
  I21RENDETAS_res_F3: 'F3',
  I21RENDETAS_res_F4: 'F4',
  I21RENDETAS_res_somme: 'Somme',
  I21RENDETAS_res_rendementSon: 'Rendement (Son)',
  I21RENDETAS_res_rendement: 'Rendement saisonnier'
}
